import { Injectable } from '@angular/core';
import { UserService } from './user.service';

@Injectable({
    providedIn: 'root',
})
export class PermissionService {
    constructor(private userService: UserService) {}

    hasPermissions(
        permissions: string[],
        allOrAny: 'all' | 'any' = 'any'
    ): boolean {
        const user = this.userService.getUser();
        let mustHavePermissions: string[] = [];
        let canHavePermissions: string[] = [];
        if (!user || !user.privileges) {
            return false;
        }

        permissions.forEach(permission => {
            if (permission.includes('!')) {
                mustHavePermissions.push(permission.replace('!', ''));
            } else {
                canHavePermissions.push(permission);
            }
        });

        if (mustHavePermissions.length > 0) {
            return (
                mustHavePermissions.every(
                    permission => !!user.privileges[permission]
                ) &&
                canHavePermissions.some(
                    permission => !!user.privileges[permission]
                )
            );
        } else {
            return permissions.some(
                permission => !!user.privileges[permission]
            );
        }
    }

    hasPrivilegeStaffPlanningRead(): boolean {
        let success = false;
        if (
            this.hasPermissions(['project_management_read'])
        ) {
            success = true;
        } else if (
            this.hasPermissions([
                'staff_planning_job_read_active',
            ])
        ) {
            success = true;
        } else if (
            this.hasPermissions([
                'staff_planning_vehicles_read_active',
            ])
        ) {
            success = true;
        }
        return success;
    }
}
